<template>
    <v-card flat v-if="orgid !==''">
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-container container--fluid class="service-area-setup signup-container">
            <!-- Regular Pricing Zip Codes -->
            <div>
                <div class="wrap-list">
                    <v-layout class="wrap-list-elements">
                        <v-flex>
                            <v-card-text class="zipcode-list-title"><h2 class="title mb-4">{{titles[0].text}}</h2>
                            </v-card-text>
                            <v-list class="regular-zip-code-list">
                                <v-list-item v-for="item in zipCodes.filter(i => i.type == types[0].text)" :key="item.value">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.value }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                    </v-layout>
                    <!-- Alert -->
                    <v-alert
                            :value="alerts[0].alert"
                            :color="alerts[0].color"
                            transition="slide-y-transition"
                    >
                        <div class="wrap-alert-close-icon">
                            <v-icon @click="closeAlert(0)" class="alert-close-icon">
                                close
                            </v-icon>
                        </div>
                        <div class="wrap-alert-icon">
                            <v-icon>
                                {{alerts[0].icon}}
                            </v-icon>
                        </div>
                        {{alerts[0].text}}
                        <br>
                        <div class="error-response">
                            {{alerts[0].text_zip_codes }}
                        </div>
                    </v-alert>
                </div>
                <!-- Add Regular Pricing Zip Codes -->
                <v-card-text :class="{ 'px-0': $vuetify.breakpoint.xs }">
                    <v-layout class="wrap">
                        <v-flex d-flex xs12 md3>
                            <div class="bold-text mb-4 pr-4">{{titles[1].text}}</div>
                        </v-flex>
                        <v-flex d-flex xs12 md9>
                            <v-layout>
                                <v-text-field
                                    class="pt-0 pr-4"
                                    v-model="add_regular_zip"
                                    :label="labels[0].text"
                                    required
                                >
                                </v-text-field>
                                <v-flex :style="{ maxWidth: $vuetify.breakpoint.smAndDown ? '100px' : '120px' }">
                                    <v-btn
                                        class="success text-none"
                                        :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : ''"
                                        :small="$vuetify.breakpoint.smAndDown"
                                        block
                                        type="submit"
                                        @click.native="checkZipCode(types[0].text, add_regular_zip, 0, true)"
                                    >Add
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <!-- Delete Regular Pricing Zip Codes -->
                <v-card-text :class="{ 'px-0': $vuetify.breakpoint.xs }">
                    <v-layout class="wrap">
                        <v-flex d-flex xs12 md3>
                            <div class="bold-text mb-4 pr-4">{{titles[2].text}}</div>
                        </v-flex>
                        <v-flex d-flex xs12 md9>
                            <v-layout>
                                <v-text-field
                                    class="pt-0 pr-4"
                                    :label="labels[1].text"
                                    v-model="delete_regular_zip"
                                >
                                </v-text-field>
                                <v-flex :style="{ maxWidth: $vuetify.breakpoint.smAndDown ? '100px' : '120px' }">
                                    <v-btn
                                        class="error text-none"
                                        :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : ''"
                                        :small="$vuetify.breakpoint.smAndDown"
                                        block
                                        type="submit"
                                        @click.native="checkZipCode(types[0].text, delete_regular_zip, 0, false)"
                                    >Delete
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <!-- How to Use Regular -->
                <v-card-text class="left-padding" :class="{ 'px-0': $vuetify.breakpoint.xs }">
                    <v-layout class="wrap">
                        <v-flex d-flex xs12 md3></v-flex>
                        <v-flex xs12 md9>
                            <div><em>How to use</em></div>
                            <ul class="left-padding">
                                <li><em>Comma(,) acts like a separator</em></li>
                                <li><em>Example: If you want to add/remove 80002, 80003, 80004, 80005, 80006, 80007, 80008,
                                    80009, 80010
                                    to modify Zip Code Service Area, the input should be:</em>
                                    <ul class="left-padding">
                                        <li><em>80002 or</em></li>
                                        <li><em>80002, 80004, 80010, 80008, 80003, 80011, 80013</em></li>
                                    </ul>
                                </li>
                            </ul>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </div>
            <!-- Premium Pricing Zip Codes -->
            <div class="wrap-list">
                <v-layout>
                    <v-flex>
                        <v-card-text class="premium-zip-code-title"><h2 class="title mb-4">{{titles[3].text}}</h2>
                        </v-card-text>
                        <v-list class="premium-zip-code-list">
                            <v-list-item v-for="item in zipCodes.filter(i => i.type == types[1].text)" :key="item.value">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.value }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-flex>
                </v-layout>
                <!-- Alert -->
                <v-alert
                        :value="alerts[1].alert"
                        :color="alerts[1].color"
                        transition="slide-y-transition"
                >
                    <div class="wrap-alert-close-icon">
                        <v-icon @click="closeAlert(1)" class="alert-close-icon">
                            close
                        </v-icon>
                    </div>
                    <div class="wrap-alert-icon">
                        <v-icon>
                            {{alerts[1].icon}}
                        </v-icon>
                    </div>
                    {{alerts[1].text}}
                    <br>
                    {{alerts[1].text_zip_codes}}
                </v-alert>
            </div>
            <!-- Add Premium Pricing Zip Codes -->
            <v-card-text :class="{ 'px-0': $vuetify.breakpoint.xs }">
                <v-layout class="wrap">
                    <v-flex d-flex xs12 md3>
                        <div class="bold-text mb-4 pr-4">{{titles[4].text}}</div>
                    </v-flex>
                    <v-flex d-flex xs12 md9>
                        <v-layout>
                            <v-text-field
                                class="pt-0 pr-4"
                                v-model="add_premium_zip"
                                :label="labels[0].text"
                            >
                            </v-text-field>
                            <v-flex :style="{ maxWidth: $vuetify.breakpoint.smAndDown ? '100px' : '120px' }">
                            <v-btn
                                class="success text-none"
                                :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : ''"
                                :small="$vuetify.breakpoint.smAndDown"
                                block
                                @click.native="checkZipCode(types[1].text, add_premium_zip, 1, true)"
                            >Add
                            </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <!-- Delete Premium Pricing Zip Codes -->
            <v-card-text :class="{ 'px-0': $vuetify.breakpoint.xs }">
                <v-layout class="wrap">
                    <v-flex d-flex xs12 md3>
                        <div class="bold-text mb-4 pr-4">{{titles[5].text}}</div>
                    </v-flex>
                    <v-flex d-flex xs12 md9>
                        <v-layout>
                            <v-text-field
                                class="pt-0 pr-4"
                                :label="labels[1].text"
                                v-model="delete_premium_zip"
                            >
                            </v-text-field>
                            <v-flex :style="{ maxWidth: $vuetify.breakpoint.smAndDown ? '100px' : '120px' }">
                                <v-btn
                                    class="error text-none"
                                    :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : ''"
                                    :small="$vuetify.breakpoint.smAndDown"
                                    block
                                    type="submit"
                                    @click.native="checkZipCode(types[1].text, delete_premium_zip, 1, false)"
                                >Delete
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <!-- How to Use Premium-->
            <v-card-text class="left-padding" :class="{ 'px-0': $vuetify.breakpoint.xs }">
                <v-layout class="wrap">
                    <v-flex d-flex xs12 md3></v-flex>
                    <v-flex xs12 md9>
                        <div><em>How to use</em></div>
                        <ul class="left-padding">
                            <li><em>Comma(,) acts like a separator</em></li>
                            <li><em>Example: If you want to add/remove 80002, 80003, 80004, 80005, 80006, 80007, 80008,
                                80009, 80010
                                to modify Zip Code Service Area, the input should be:</em>
                                <ul class="left-padding">
                                    <li><em>80002 or</em></li>
                                    <li><em>80002, 80004, 80010, 80008, 80003, 80011, 80013</em></li>
                                </ul>
                            </li>
                        </ul>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-container>
    </v-card>
    <v-card flat v-else>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-container v-if="loading == false" class="onboarding-error-message">
            <h1>!</h1><h5>Something went wrong!</h5><h5>Please refresh your browser and try again.</h5>
        </v-container>
    </v-card>
</template>

<script>
    import ApiService from "../../../common/api.service";

    export default {
        props: ['orgid'],
        data() {
            return {
                zipCodes: [],
                loading: true,
                add_regular_zip: '',
                add_premium_zip: '',
                delete_regular_zip: '',
                delete_premium_zip: '',
                regexZip: /^\d{5}$/,
                zipType: '',
                duplicatedCodes: [],
                regular_zip_codes: [],
                premium_zip_codes: [],
                newReg: [],
                newPrem: [],
                error_code: '',
                titles: [
                    {text: 'Regular Pricing Zip Codes'},
                    {text: 'Add Regular Pricing Zip Codes'},
                    {text: 'Delete Regular Pricing Zip Codes'},
                    {text: 'Premium Pricing Zip Codes'},
                    {text: 'Add Premium Pricing Zip Codes'},
                    {text: 'Delete Premium Pricing Zip Codes'},
                ],
                labels: [
                    {text: 'Add new Zip Codes'},
                    {text: 'Delete Zip Codes'}
                ],
                types: [
                    {text: 'regular'},
                    {text: 'premium'},
                ],
                alerts: [
                    {alert: false, color: '', icon: '', text: ''},
                    {alert: false, color: '', icon: '', text: ''}
                ],
                alertFlag: true,
            }
        },
        beforeMount() {
            this.getZipCodes();
        },
        methods: {
            getZipCodes() {
                ApiService.get(`/client_on_boarding_setup/pricing_zip_codes/${this.orgid}`)
                    .then(response => {
                        this.zipCodes = response.data.pricing_zip_code.sort((a, b) => (a.value > b.value) ? 1 : -1);
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            checkZipCode(type, value, index, inputType) {
                //Make a seperated regular and premium arrays form response
                let zipcodesResponse = this.zipCodes;
                for (let i in zipcodesResponse) {
                    if (zipcodesResponse[i].type === "regular") {
                        this.regular_zip_codes.push(zipcodesResponse[i].value)
                    } else if (zipcodesResponse[i].type === "premium") {
                        this.premium_zip_codes.push(zipcodesResponse[i].value)
                    }
                }
                //Declare new value from input
                let newValue;
                //Close all alerts if they exist on previous click
                this.alerts[0].alert = false
                this.alerts[1].alert = false
                //Turn on loader
                this.loading = true;
                //Remove all empty spaces in input
                value = value.replace(/ /g, ',');
                value = value.split(',').filter(i => i !== '').join()
                //If field is empty
                if (value === "") {
                    this.getAlert(!this.alertFlag, index, 'Input field is empty! Please enter zip code number!');
                    this.loading = false;
                    //Regex validation
                } else if (value.split(',').some(i => !this.regexZip.test(i))) {
                    this.getAlert(!this.alertFlag, index, 'Please enter valid zip code number format!');
                    this.loading = false;
                } else {
                    //Make a new value of single or mulitple input seperated by comma
                    newValue = value.split(',');
                    //If number is from ADD input field (true)
                    if (inputType) {
                        //Call a method for cheking if number does not exist in a lists
                        this.checkIfNumberExist(value, newValue, type, index);
                        //If number is from DELETE input field (false)
                    } else {
                        //Call a method for checking if number exist in a lists
                        this.checkIfNumberNotExist(value, newValue, type, index);
                    }
                }
            },
            //Check if number for add already exist in a list
            checkIfNumberExist(value, newValue, type, index) {
                let zipsArray = this.zipCodes;
                let newStr = [];
                //Make a string array (newStr) of the existing zip codes in regular and premium
                for (let i in zipsArray) {
                    if (zipsArray[i].value !== "") {
                        newStr.push(zipsArray[i].value)
                    }
                }
                //Make a new Array of duplicated existing input numbers in a list of zip codes
                for (let j in newValue) {
                    if (newStr.join().includes(newValue[j])) {
                        this.duplicatedCodes.push(newValue[j])
                    }
                }
                //Array of duplicated codes is not empty
                if (this.duplicatedCodes.length !== 0) {
                    let zipStr = this.duplicatedCodes.join(', ');
                    //Show alert that code are already exists in regular or premium list
                    this.getAlert(!this.alertFlag, index, 'The following  Zip code numbers already exist in Regular or Premium pricing zip code lists:', zipStr)
                    this.loading = false;
                    //Make empty array of duplicated zip codes for next checking
                    this.duplicatedCodes = [];
                } else {
                    //Send codes to post
                    this.sendToPost(type, value, index);
                }
                //this.addZipCode(type,value,index);
            },
            //Check if number for delete  not exist in a list
            checkIfNumberNotExist(value, newValue, type, index) {
                //Check which tipe is
                if (type === "regular") {
                    //Make a new Arrays of non existing input numbers in a list of zip codes
                    for (let i in newValue) {
                        if (!this.regular_zip_codes.join().includes(newValue[i])) {
                            this.newReg.push(newValue[i])
                        }
                    }
                } else if (type === "premium") {
                    for (let j in newValue) {
                        if (!this.premium_zip_codes.join().includes(newValue[j])) {
                            this.newPrem.push(newValue[j])
                        }
                    }
                }
                //If input number is not in a list (new array is not empty)
                if (this.newReg.length !== 0) {
                    //Show alert with non existing codes in a regular zip code list
                    this.getAlertOfCodes(this.newReg, type, index);
                } else if (this.newPrem.length !== 0) {
                    //Show alert with non existing codes in a premium zip code list
                    this.getAlertOfCodes(this.newPrem, type, index);
                } else {
                    //If input number/s is in a list send to the delete
                    this.sendToDelete(type, value, index)
                }
            },
            //Post new zip codes
            sendToPost(type, value, index) {
                ApiService.post(`/client_on_boarding_setup/pricing_zip_code?organization_form_id=${this.orgid}&type=${type}&value=${value}`)
                    .then(response => {
                        //Update lists from response
                        this.zipCodes = response.data.pricing_zip_code.sort((a, b) => (a.value > b.value) ? 1 : -1);
                        //Empty input fields
                        if (type === 'regular') {
                            this.add_regular_zip = "";
                        } else if (type === 'premium') {
                            this.add_premium_zip = "";
                        }
                        this.getAlert(this.alertFlag, index, 'Zip code successfully added.')
                        this.loading = false;
                    })
                    .catch(error => {
                        this.getAlert(!this.alertFlag, index, 'Save unsuccessful!.')
                        this.loading = false;
                        console.log(error)
                    });
            },
            //Delete existing zip codes
            sendToDelete(type, value, index) {
                ApiService.delete(`/client_on_boarding_setup/pricing_zip_code?organization_form_id=${this.orgid}&type=${type}&value=${value}`, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                    .then(response => {
                        //Update lists from response
                        this.zipCodes = response.data.pricing_zip_code.sort((a, b) => (a.value > b.value) ? 1 : -1);
                        //Empty input fields
                        if (type === 'regular') {
                            this.delete_regular_zip = "";
                        } else if (type === 'premium') {
                            this.delete_premium_zip = "";
                        }
                        this.getAlert(this.alertFlag, index, 'Zip code successfully deleted!');
                        this.loading = false;
                    })
                    .catch(error => {
                        this.getAlert(!this.alertFlag, index, 'Unsuccessful delete!')
                        this.loading = false;
                    });
            },
            //Get alert with lsit of no existing codes
            getAlertOfCodes(newArray, type, index) {
                let zipStr = newArray.toString();
                this.getAlert(!this.alertFlag, index, 'The following  Zip code numbers does not exist in '
                    + this.makeCapitalFirstLetter(type) +
                    ' pricing zip codes list:', zipStr)
                this.loading = false;
                //Make empty array of no existing zip codes for next checking
                this.newReg = [];
                this.newPrem = [];
            },
            //Get alert for success or error
            getAlert(flag, index, message, zipcodes) {
                if (flag === true) {
                    this.alerts[index].alert = flag;
                    this.alerts[index].color = 'success';
                    this.alerts[index].icon = 'check_circle';
                    this.alerts[index].text = message;
                    this.alerts[index].text_zip_codes = zipcodes;
                    setTimeout(() => {
                        this.alerts[index].alert = false
                    }, 3000);
                } else {
                    this.alerts[index].alert = true;
                    this.alerts[index].color = 'error';
                    this.alerts[index].icon = 'error';
                    this.alerts[index].text = message;
                    this.alerts[index].text_zip_codes = zipcodes;
                }
            },
            //Make a firts character capital of string from response
            makeCapitalFirstLetter(str) {
                return _.upperFirst(str.replace(/_/g, ' '));
            },
            //Close Alert
            closeAlert(index) {
                this.alerts[index].alert = false;
            }
        }
    };
</script>
